export default __webpack_public_path__ + "img/Slider9.c51ef6f4.png";